import { render, staticRenderFns } from "./TransectionChart.vue?vue&type=template&id=95ea98f8&"
import script from "./TransectionChart.vue?vue&type=script&lang=js&"
export * from "./TransectionChart.vue?vue&type=script&lang=js&"
import style0 from "./TransectionChart.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports